import Image from "next/legacy/image"
import useStore from "components/ui/Context"
import { useState } from "react"
import { renderTimeFromNow, renderTime, convertSeccondToTimePlay } from "utils/time"
import TagPremium from "components/TagPremium"

function CardShortItem({
  is_live,
  name,
  start_time,
  status,
  duration,
  thumbnail_vertical,
  // is_premium,
  created,
  hideText,
  showTime = true,
  package_type,
  is_monopoly = false
}) {
  const setModalLive = useStore().setModalLive
  const [srcImage, setSrcImage] = useState(thumbnail_vertical)
  function nextPath() {
    if (status !== "live" && is_live) {
      setModalLive({
        show: true,
        isVod: true,
        info: {
          title: name,
          start_time
        }
      })
    }
  }
  return (
    <div onClick={nextPath} role="button" tabIndex="0" onKeyPress={() => {}} className="h-full">
      <div className="relative h-full">
        <div className="relative wapper__play h-full">
          <div className="fix_img">
            <Image
              className="rounded-lg bg-dark-900 object-cover"
              src={srcImage}
              layout="fill"
              alt={name}
              onError={() => setSrcImage("https://stvinaprod.vtvcab.vn/4ab5f0e3-d616-4834-9485-d54b0ebb7115.png")}
            />
          </div>
          <div className="layer__play rounded-lg">
            <div className="icon__play">
              <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.7035 0.973862C1.03778 0.550219 0.166626 1.02843 0.166626 1.81752V18.5909C0.166626 19.3799 1.03778 19.8582 1.7035 19.4345L14.8825 11.0478C15.5 10.6549 15.5 9.75348 14.8825 9.36053L1.7035 0.973862Z"
                  fill="#006DFF"
                />
              </svg>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 w-full p-3 z-10 min-h-[56px]">
            <p className="text-xs font-bold text-white md:text-xs line-clamp-2">{name}</p>
          </div>
          <div
            className="absolute w-full h-full right-0 top-0 rounded-lg"
            style={{ background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.8) 100%)" }}
          ></div>
        </div>
      </div>
    </div>
  )
}
export default CardShortItem
